import {Box, Typography} from '@mui/material';
import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {useEffect} from 'react';
import {useTranslation} from 'tolgee';

import {Route as RouteEnum} from '~utils/routeUtil';
import {selectCurrentProjectId} from '~redux/reducers/userReducer';
import {useAppSelector} from '~redux/index';

import {Container, LayoutContent, LayoutHeader} from '~components/_layout/layoutComponents';
import {MainTitleBar} from '~components/header/MainTitleBar';

export const Route = createFileRoute('/no-projects')({
  component: NoProjectsPage,
});

function NoProjectsPage() {
  const {t} = useTranslation('common');
  const navigate = useNavigate();
  const currentProjectId = useAppSelector(selectCurrentProjectId);

  useEffect(() => {
    if (currentProjectId !== null) {
      navigate({to: RouteEnum.index as any});
    }
  }, [currentProjectId, navigate]);

  if (currentProjectId !== null) {
    return null;
  }

  return (
    <Container>
      <LayoutHeader>
        <MainTitleBar showOnboardingGuide={false} showBackButton={false} showUserMenu={true} />
      </LayoutHeader>
      <LayoutContent>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            height: '100%',
            paddingTop: 2,
            maxWidth: 500,
            margin: '0 auto',
            gap: 8,
          }}
        >
          <Box>
            <img src={'/images/maddox-ai-logo.svg'} alt='' width={120} />
          </Box>
          <Box>
            <Typography variant='h1' sx={{marginBottom: 3, fontWeight: 'bold'}}>
              {t('noProjects.title')}
            </Typography>
            <p>{t('noProjects.description')}</p>
          </Box>
        </Box>
      </LayoutContent>
    </Container>
  );
}
